const Showreel = {
	init: function (holder) {
		const videoElement = holder.querySelector('video');

		if (Hls.isSupported()) {
			const hls = new Hls();
			hls.loadSource(videoElement.dataset.videoUrl);
			hls.attachMedia(videoElement);
			videoElement.play();
		} else if (videoElement.canPlayType('application/vnd.apple.mpegurl')) {
			videoElement.src = videoElement.dataset.videoUrl;
			videoElement.play();
		} else {
			console.warn('HLS is not supported for this browser');
		}

		let muted = true;


		const muteBtn = holder.querySelector('[data-control="mute"]');
		const toggleMuteIcon = () => {
			if (muted) {
				muteBtn.querySelector('.bi-volume-mute-fill').classList.remove('d-none');
				muteBtn.querySelector('.bi-volume-up-fill').classList.add('d-none');
			} else {
				muteBtn.querySelector('.bi-volume-mute-fill').classList.add('d-none');
				muteBtn.querySelector('.bi-volume-up-fill').classList.remove('d-none');
			}
		};

		holder.querySelectorAll('[data-control]').forEach(btn => {
			btn.addEventListener('click', () => {
				if (btn.dataset.control === 'rewind') {
					muted = false;
					videoElement.currentTime = 0;
					videoElement.muted = muted;
					videoElement.play();
					toggleMuteIcon();

					const elementRect = holder.getBoundingClientRect();
					const elementBottom = elementRect.bottom + window.scrollY;

					window.scrollTo({
						top: elementBottom - window.innerHeight,
						behavior: 'smooth',
					});
				} else {
					muted = !muted;
					videoElement.muted = muted;
					videoElement.play();
					toggleMuteIcon();


				}
			});
		});




		const initialVideoSize = 60;

		let ratio = 0.0;



		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					if (entry.intersectionRatio <= ratio) {
						return;
					}
					ratio = entry.intersectionRatio;
					const wh = Math.min(100, ((100 - initialVideoSize) * ratio) + initialVideoSize);
					videoElement.style.width = wh + 'vw';
					videoElement.style.height = wh + 'vh';
				}
			});
		}, {
			threshold: Array.from({ length: 101 }, (_, i) => i / 100) // Create thresholds from 0 to 1
		});

		// Observe the scale element
		observer.observe(videoElement);






	},
};

export default Showreel;
